jQuery(document).ready(function($) {
$('img[src^="//creativpartysupplies.com/cdn/shop/files/Search.png"]').attr('alt', 'Search icon');
$('img[src^="//creativpartysupplies.com/cdn/shop/files/Term-and-conditions.png"]').attr('alt', 'Terms and conditions icon');
$('img[src^="//creativpartysupplies.com/cdn/shop/files/Shipping-and-returns.png"]').attr('alt', 'Shipping and returns icon');
$('img[src^="//creativpartysupplies.com/cdn/shop/files/PrivacyPolicy.png"]').attr('alt', 'Privacy Policy icon');
$('img[src^="//creativpartysupplies.com/cdn/shop/files/ContactUs.png"]').attr('alt', 'Telephone icon');
$('img[src^="//creativpartysupplies.com/cdn/shop/files/accessibility.png"]').attr('alt', 'Accessibility icon');
$('input[name="contact[email]"]').attr("aria-label","Enter your email address");
  $('input[name="contact[email]"]').attr("aria-required","true");
  $("select[name='sort_by'].hide.cf__sort-by").removeAttr("aria-describedby");
$('a.promo__text').attr('role', 'button');
$('a.promo__close').attr('role', 'button');
$('a.search__input--desktop').attr('role', 'button');
$('a.bt-sidebar-btn').attr('role', 'button');
$('a.back-top__button').attr('role', 'button');
$('a.cookie_consent__close').attr('role', 'button');
$('i.lnr-cross').attr('role', 'presentation');
$('i.lnr-magnifying-glass').attr('role', 'presentation');
$('i.lnr-user').attr('role', 'presentation');
$('i.lnr-shopping-bag').attr('role', 'presentation');
$('i.lnr-smartphone').attr('role', 'presentation');
$('i.lnr-envelope').attr('role', 'presentation');
$('i.lnr-shopping-cart').attr('role', 'presentation');
$('i.lnr-chevron-up').attr('role', 'presentation');
$("img[srcset^='//creativpartysupplies.com/cdn/shop/files/hero-banner-one_180x.jpg?v=1647853544 180w']").attr("alt","banner image");
$('img[src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="]').attr('alt', 'creativ party supplies logo');
//$('img[src^="https://cdn.shopify.com/s/files/1/0249/0099/3104/files/creativ-logo_x320.png"]').attr('alt', 'creativ party supplies logo');
$('input[name="shipping_address[zip]"]').attr('aria-label', 'Enter zip address');
$("tr.cart__row.cart__header>th").append("<span style='display:none'>.</span>");
$("button.cart__qty-control").append("<span style='display:none'>.</span>");
  $("input.qty-box__input").attr("aria-label","Enter quantity");
  $('a[href="/collections/all-sparklers-1"]').attr("aria-label","All sparklers collection");
$("a.promo__close").attr("aria-label","promo close")
   $("button.js-modal-btn.js-modal-btn--youtube.hide").append("<span style='display:none'>.</span>");
    $("button.js-modal-btn.js-modal-btn--vimeo.hide").append("<span style='display:none'>.</span>");
    $("button.search-full__submit[type='submit']").attr("aria-label","submit for search");
  //$("button.search-full__submit[type='submit']").append("<span style='display:none'>.</span>");
 $('div[role="dialog"][aria-modal="true"]').removeAttr('aria-describedby');
$("button.shopify-payment-button__more-options").append("<span style='display:none'>.</span>");
$("button.shopify-payment-button__button").append("<span style='display:none'>.</span>");
$("a.infinite-scroll.collection__scroll.loading-not-full").attr("aria-label", "Scroll for next products");
  $("a[title='Back to top']").attr("aria-label", "back to top");
  $('a.button.button--banner').css({
    'background': 'none',
    'background-color': 'rgba(0, 0, 0, 0.005) !important'
});

  $("a.button.button--banner").each(function() {
        var link = $(this);
        var linkText = "Shop Now";
        link.empty().append('<span class="bc">' + linkText + '</span>');
    });
setTimeout(function() {
    $("i.lnr-check").parent().append("<span style='display:none'>.</span>");
   $("img[src='https://d3k81ch9hvuctc.cloudfront.net/company/RhHQvr/images/79521cf8-925c-4edc-9bf8-ebd866144630.png']").attr("alt", "celebration");
   $('img[src^="https://cdn.shopify.com/s/files/1/0249/0099/3104/files/creativ-logo_x320.png?v=1647595564"]').attr('alt', 'creativ party supplies logo');
$('input[name="shipping_address[zip]"]').attr('aria-label', 'Enter zip address');
  $('input[name="address[zip]"]').attr('aria-label', 'Enter zip address');
}, 1000);

  console.log( "ready!" );
});